import { mapMovementType } from './movement-type.ts';
import { mapMovementTypeGroup } from './movement-type-group.ts';
import type { IMovementType, IMovementTypeGroup } from '../types';
import type { MovementTypesResponse } from '@/shared/api/experience';

export const createMovementTypesFromResource = (rawData: MovementTypesResponse) => {
  if (!rawData.movement_type || !rawData.movement_type_group) {
    return { movementTypes: [], movementTypeGroups: [] };
  }

  const movementTypes: IMovementType[] = rawData.movement_type.map(mapMovementType);

  const movementTypeGroups: Array<IMovementTypeGroup | null> = rawData.movement_type_group.map((group) =>
    mapMovementTypeGroup(group, rawData.movement_type_group_map),
  );

  const movementTypesExpCardLabels = movementTypes.reduce(
    (acc, movementType) => {
      acc[movementType.str] = movementType.labelPhrase;

      return acc;
    },
    {} as Record<string, string>,
  );

  return { movementTypes, movementTypeGroups, movementTypesExpCardLabels };
};
